import { Delete, Edit, MoreVertOutlined } from '@mui/icons-material';
import { IconButton, MenuItem, Popover } from '@mui/material';
import { useState } from 'react';
import { VesselOption } from '../../../models/my-fleet.model';

interface MyFleetVesselMoreOptionsProps {
  onOptionSelection: (Option: VesselOption) => void;
  onDeleteAlert: (alert_id: string) => void;
  proAlertId?: string | null;
  vesselImo?: string | null;
}

function MyFleetVesselMoreOptions({
  onOptionSelection,
  onDeleteAlert,
  proAlertId,
  vesselImo,
}: MyFleetVesselMoreOptionsProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  const handleEdit = () => {
    onOptionSelection(VesselOption.Edit);
    handleClose();
  };

  const handleAlert = () => {
    onOptionSelection(VesselOption.Alert);
    handleClose();
  };

  const handleDeleteAlert = () => {
    if (!proAlertId) return;
    onDeleteAlert(proAlertId);
    handleClose();
  };

  return (
    <>
      <IconButton
        sx={{ fontSize: '22px', color: 'secondary.main' }}
        onClick={handleOpen}
        aria-label="My fleet vessel more options"
        data-testid={`my-fleet-vessel-more-options-button-${vesselImo}`}
      >
        <MoreVertOutlined fontSize="small" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        data-testid="my-fleet-vessel-more-options-popover"
      >
        <MenuItem
          onClick={() => handleEdit()}
          data-testid={`edit-vessel-option-${vesselImo}`}
        >
          <Edit
            fontSize="small"
            sx={{ ml: 0, mr: 0.5, verticalAlign: 'middle' }}
          />
          Edit Vessel
        </MenuItem>
        <MenuItem
          onClick={() => handleAlert()}
          data-testid={`pro-alert-option-${vesselImo}`}
        >
          <Edit
            fontSize="small"
            sx={{ ml: 0, mr: 0.5, verticalAlign: 'middle' }}
          />
          {proAlertId ? 'Edit PRO Alert' : 'Create PRO Alert'}
        </MenuItem>
        {!!proAlertId && (
          <MenuItem
            onClick={() => handleDeleteAlert()}
            data-testid={`delete-pro-alert-option-${vesselImo}`}
          >
            <Delete
              fontSize="small"
              sx={{ ml: 0, mr: 0.5, verticalAlign: 'middle' }}
            />
            Delete PRO Alert
          </MenuItem>
        )}
      </Popover>
    </>
  );
}

export default MyFleetVesselMoreOptions;

MyFleetVesselMoreOptions.defaultProps = {
  proAlertId: null,
  vesselImo: null,
};
